import { gql } from '@apollo/client'
import React from 'react'

import { generalClient } from '../../../../utils/apollo/api'
import { useModalData } from '../../../../components/modals/ModalsContext'
import { useQuery } from '../../../../utils/apollo/_helpers/useQuery'
import StatePresenter from '../../../../components/helpers/StatePresenter'

const Context = React.createContext([])
const { Provider } = Context
export const useTagState = () => React.useContext(Context)
export const useTag = () => useTagState()?.tag

const QUERY = gql`
  query Tag($id: ID!) {
    tag(id: $id, filter: { includeDeleted: true }) {
      id
      name
      color
      type
    }
  }
`

const TagLoader = ({ children }) => {
  const { id } = useModalData() || {}

  const { data, ...state } = useQuery(QUERY, {
    skip: !id,
    variables: { id },
    client: generalClient,
    fetchPolicy: 'no-cache'
  })

  return (
    <StatePresenter {...state}>
      <Provider value={data}>{children}</Provider>
    </StatePresenter>
  )
}

export default TagLoader
